
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "9778f514-a481-4c7e-b8bd-122b80c191e2"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/app/base/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
